var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"mt-1"},_vm._l((_vm.companies),function(com,index){return _c('v-col',{key:index,attrs:{"cols":"2"}},[_c('v-card',[_c('v-card-title',{staticClass:"d-flex flex-column justify-center"},[_c('v-icon',[_vm._v(" mdi-home-city-outline ")]),_c('h4',[_vm._v(" "+_vm._s(com.name)+" ")])],1)],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }